import { createSlice } from "@reduxjs/toolkit";
import { elements } from "constants/types";
import { folderBy } from "layout/dictionarySearch/constants";
import * as dictionarySearchReducers from "slices/dictionarySearch/helpers";
import * as discoveryHelpers from "slices/discovery/helpers/config";

const initialState = {
  folder: { dictionary: { categories: [] }, documents: [] },
  documents: [],
  content: { data: [] },
  config: {
    export: { modal: 0, action: undefined },
    isSearch: false,
    folderBy: folderBy.folder,
    folderId: undefined,
    documentId: undefined,
    loading: [
      {
        element: elements.CONTENT,
        loading: false,
      },
    ],
  },
};

export const dictionarySearchSlice = createSlice({
  name: "dictionarySearch",
  initialState,
  reducers: {
    resetDictionarySearch: (state) => {
      // full reset
      state = {
        ...initialState,
        config: {
          ...initialState.config,
          folderBy: state.config.folderBy,
          export: {
            modal: state.config.export?.modal ?? 0,
            action: state.config.export?.action,
          },
        },
      };
      return state;
    },
    setDictionaries: (state, action) => {
      state.dictionaries = action.payload;
    },
    setSelectedFolderAndDocument: (state, action) => {
      state.config.folderId = action.payload.folderId;
      state.config.documentId = action.payload.documentId;
    },
    setExportAction: (state, action) => {
      state.config.export.action = action.payload;
    },
    setExportModal: (state, action) => {
      state.config.export.modal = action.payload;
    },
    setFolderBy: (state, action) => {
      state.config.folderBy = action.payload;
    },
    setDataPrevLength: (state) => {
      const prevLength = state.content.data ? state.content.data.length : 0;
      state.content.previousLength = prevLength;
    },
    setContentData: (state, action) => {
      state.content.data = action.payload;
    },
    setExpandedTo: dictionarySearchReducers.setExpandedTo,
    setDocumentCheckState: dictionarySearchReducers.setDocumentCheckState,
    setCategoryCheckState: dictionarySearchReducers.setCategoryCheckState,
    setItemCheckState: dictionarySearchReducers.setItemCheckState,
    setDocCheckState: dictionarySearchReducers.setDocCheckState,
    setDocExpandState: dictionarySearchReducers.setDocExpandState,
    setAllExpandedTo: dictionarySearchReducers.setAllExpandedTo,
    setAllCheckedStateTo: dictionarySearchReducers.setAllCheckedStateTo,
    setCategories: dictionarySearchReducers.setCategories,
    setLoading: discoveryHelpers.setLoading,
  },
});

export const {
  resetDictionarySearch,
  setDictionaries,
  setSelectedFolderAndDocument,
  setExportAction,
  setExportModal,
  setFolderBy,
  setDataPrevLength,
  setContentData,
  setExpandedTo,
  setDocumentCheckState,
  setCategoryCheckState,
  setItemCheckState,
  setDocCheckState,
  setDocExpandState,
  setAllExpandedTo,
  setAllCheckedStateTo,
  setCategories,
  setLoading,
} = dictionarySearchSlice.actions;

export default dictionarySearchSlice.reducer;
